import "./i18n";
import React from "react";
import { Navigate, type RouteObject, useLocation } from "react-router-dom";

const LoginPage = React.lazy(() => import("./login"));
const ActivateAccount = React.lazy(() => import("./activate-account"));
const ForgotPassword = React.lazy(() => import("./forgot-password"));
const ValidatePassword = React.lazy(() => import("./validate-password"));
const DoubleAuth = React.lazy(() => import("./double-auth"));
const ErrorPage = React.lazy(() => import("@root/error"));

const RedirectToForgotPassword = () => {
  const { search } = useLocation();

  return <Navigate to={`/forgot-password${search}`} replace />;
};

export const accountRoutes: RouteObject[] = [
  {
    path: "/activate-account",
    element: <ActivateAccount />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/change-password",
    element: <RedirectToForgotPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/new-password",
    element: <ValidatePassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/double-auth",
    element: <DoubleAuth />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/login",
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
];
